import { inject, Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError, first } from 'rxjs/operators';

import { ServerTimeSyncService } from 'app/shared/services/server-time-sync-service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _serverTimeOffset = 0;
  private readonly _serverTimeSyncService = inject(ServerTimeSyncService);

  public constructor() {
    this.syncServerTimeOffset();
  }

  public getDate(): Date {
    return new Date(Date.now() + this._serverTimeOffset);
  }

  private syncServerTimeOffset(): void {
    this._serverTimeSyncService.getTimeSkew()
      .pipe(
        first(),
        catchError(() => EMPTY)
      )
      .subscribe((result) => {
        this._serverTimeOffset = result.skew;
      });
  }
}
